import React from 'react'
import { IconBase, OptionalIconBaseProps } from '../components/IconBase'

export const CarretDownIcon = (props: OptionalIconBaseProps) => (
  <IconBase name="carret-down" viewBox="0 0 20 20" {...props}>
    <path d="M13.1096 7.5H6.89012C6.70357 7.5 6.59941 7.70441 6.71493 7.84397L9.82465 11.5863C9.91367 11.6934 10.0851 11.6934 10.175 11.5863L13.2847 7.84397C13.4003 7.70441 13.2961 7.5 13.1096 7.5Z" />
  </IconBase>
)
